import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';
import { addAndApplyFilter, removeAndApplyFilter } from '../../../actions/filterActions';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

// styles
import style from './SbSharedRefineMenuColorSelect.scss';

export class SbSharedRefineMenuColorSelectComponent extends React.Component {
    constructor() {
        super();

        this.onChange = this.onChange.bind(this);
        this.getSelected = this.getSelected.bind(this);
    }

    getSelected() {
        const { searchBrowse, filterName } = this.props;
        const { appliedFilters } = searchBrowse;
        const appliedFilterValues = getFilterValues(appliedFilters, filterName);

        return appliedFilterValues.map(color => color.urlLabel);
    }

    onChange(colorFilter) {
        if (this.getSelected().includes(colorFilter.urlLabel)) {
            return this.props.onDeselect(colorFilter);
        }
        return this.props.onSelect(colorFilter);
    }

    render() {
        const { filter } = this.props;
        const colors = filter.values;
        const selected = this.getSelected();

        return (
            <div className={style.container}>
                {colors.map((color, idx) => (
                    <div
                        key={`${color.displayName}-${idx}`}
                        className={style.colorSelect}
                        data-color={color.displayName}
                        onClick={() => this.onChange(color)}
                        data-tn={`color-${color.displayName}`.toLowerCase()}
                    >
                        <AbsoluteAnchor
                            href={color.link}
                            title={color.displayName}
                            onClick={e => e.preventDefault()}
                        >
                            <span
                                className={classnames(style.swatch, {
                                    [style.selected]: selected.includes(color.urlLabel),
                                })}
                                style={{ backgroundColor: color.hexCode }}
                            />
                        </AbsoluteAnchor>
                    </div>
                ))}
            </div>
        );
    }
}

SbSharedRefineMenuColorSelectComponent.defaultProps = {
    onSelect: () => {},
    onDeselect: () => {},
};

SbSharedRefineMenuColorSelectComponent.propTypes = {
    filter: PropTypes.object.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func,
};

function mapDispatchToProps(dispatch, props) {
    return {
        onSelect(changedValue) {
            dispatch(addAndApplyFilter(props.filter.name, changedValue));
        },
        onDeselect(changedValue) {
            dispatch(removeAndApplyFilter(props.filter.name, changedValue));
        },
    };
}

export const SbSharedRefineMenuColorSelect = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbSharedRefineMenuColorSelectComponent),
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuColorSelect_searchBrowse on SearchBrowseQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
